// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"410":"022ea3a6","544":"43fe7c48","665":"9d60c46c","820":"fb9a3813"}[chunkId] + ".css";
};